import React from "react";
import { Button } from 'react-bootstrap';

const BUTTON_ICONS = {
    "Create New": "fas fa-plus",
    "Cancel": "fas fa-times",
    "Save": "fas fa-save",
    "Delete": "fas fa-trash",
    "Export": "fas fa-file-export",
    "Import": "fas fa-file-import",
    "Back to List": "fas fa-list",
    "Edit": "fas fa-pen",
    "Add": "fas fa-plus",
    "Add an Item": "fas fa-plus-circle",
    "Back to Details": "fas fa-arrow-left",
    "Create": "fas fa-plus",
    "Okay": "fas fa-check",
    "Search": "fas fa-search",
    "Active": "fas fa-check-circle",
    "Inactive": "fas fa-times-circle",
    "Enable": "fas fa-toggle-on",
    "Disable": "fas fa-toggle-off",
    "Send Message": "fas fa-paper-plane",
    "Apply": "fas fa-check",
    "Submit": "fas fa-sign-in-alt",
    "Sync Power BI Pages": "fas fa-refresh",
    "Syncing...": "fas fa-spinner fa-spin",
};

const DefaultButton = ({buttonClass, buttonTitle, buttonType="button", actionBlock, disabled=null}) => {

    let cName = buttonClass + ' pt-1 pb-1';
    const icon = typeof buttonTitle === "string" ? BUTTON_ICONS[buttonTitle.trim()] : null;

    return (
        <Button type={buttonType} className={cName} onClick={actionBlock} disabled={disabled} >
            {icon && <i className={`${icon} me-2`}></i>}
            {buttonTitle}
        </Button>
    );
}

export default DefaultButton;